export default "__VITE_ASSET__8499b946__"